import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { setupHead } from "./utils/head";
import { loadPixelWhenIdle } from "./utils/metaPixel";
setupHead();
// The pixel is loaded after the page is painted so it never competes with the
// hero image for bandwidth on slow connections.
loadPixelWhenIdle();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-225" data-mp="2aam5w6m67388" />);
}